var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 18V14C21 11.7895 19.2105 10 17 10H4C3.45614 10 3 10.4561 3 11C3 11.5439 3.45614 12 4 12H17C18.2281 12 19 12.7719 19 14V18C19 18.5439 19.4561 19 20 19C20.5439 19 21 18.5439 21 18ZM3.29825 11.7018L8.29825 16.7018C8.47368 16.8947 8.7193 17 9 17C9.54386 17 10 16.5439 10 16C10 15.7193 9.89474 15.4737 9.70175 15.2982L4.70175 10.2982C4.52632 10.1053 4.2807 10 4 10C3.45614 10 3 10.4561 3 11C3 11.2807 3.10526 11.5263 3.29825 11.7018ZM8.29825 5.29825L3.29825 10.2982C3.10526 10.4737 3 10.7193 3 11C3 11.5439 3.45614 12 4 12C4.2807 12 4.52632 11.8947 4.70175 11.7018L9.70175 6.70176C9.89474 6.52632 10 6.2807 10 6C10 5.45614 9.54386 5 9 5C8.7193 5 8.47368 5.10526 8.29825 5.29825Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.fca733bc.svg";
export { ForwardRef as ReactComponent };